module.exports = __webpack_public_path__ + "static/anana-vestige-journal-video-4e7b92677682f0d871bb7601cd9b86cb.mp4";